<template>
  <v-card elevation="0">
    <v-card-text>
      <v-file-input
        v-model="selectedFiles"
        label="Выберите файлы для загрузки"
        accept="video/mpeg,video/mp4,video/webm,image/jpeg,image/png"
        class="pt-1 mt-0"
        hide-details
        multiple
        @change="onUpload"
      />
      <div>
        <p class="body-text">Допустимые расширения файлов: mpeg, mp4, webm, jpeg, png.</p>
      </div>
      <div class="attachments mt-4">
        <div
          v-for="(attachment, fileIndex) in attachments"
          :key="attachment.id"
          class="attachment"
          target="_blank"
          @click="openAttachmentFile(attachment.file.path)"
        >
          <img
            v-if="isVideo(attachment)"
            class="attachment__img"
            src="~@/assets/video_icon.png"
            alt=""
          >
          <img
            v-else
            class="attachment__img"
            :src="attachment.file.blobPath"
            :alt="attachment.name"
          >
          <p class="mimetype">{{ attachment.file.name }}</p>
          <button
            type="button"
            class="attachment__remove"
            @click.stop="deleteFile(attachment.id, fileIndex)"
          />
        </div>
      </div>
      <div v-if="!single.attachments || !single.attachments.length">Нет файлов</div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { uploadAttachments } from '@/utils/requests/upload';
import { openFile, fetchAndGetURL } from '@/utils/download-file';
import { deleteLayerAttachment } from '@/services/layers';
import defaultImage from '@/assets/image.svg';

export default {
  name: 'layers-item-view-video-tab',
  props: {
    single: Object,
  },
  data: () => ({
    selectedFiles: null,
    files: [],
    attachments: [],
    isLoading: false,
  }),
  computed: {
    isVideo() {
      return file => {
        if (!file) return false;
        const { type } = file.file;
        return [
          'video/mp4',
          'video/webm',
        ].includes(type);
      };
    },
  },
  watch: {
    single: {
      deep: true,
      handler() {
        this.files = Array.from(this.single.attachments);
        this.updateAttachments();
      },
    },
  },
  created() {
    this.files = Array.from(this.single.attachments);
    this.updateAttachments();
  },
  methods: {
    ...mapActions(['showNotify']),
    ...mapActions('layer-objects', ['getItem']),

    async updateAttachments() {
      const promises = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of this.files) {
        promises.push(fetchAndGetURL(item.file.path));
      }

      const blobs = await Promise.all(promises);

      this.attachments = this.files.map((element, i) => {
        const newElement = { ...element };
        newElement.file.blobPath = blobs[i] || defaultImage;
        return newElement;
      });
    },

    async onUpload(data) {
      if (!(data && data.length)) return;

      try {
        await uploadAttachments(this.single.id, data);
        this.showNotify({
          type: 'success',
          message: 'Данные загружены',
        });

        this.selectedFiles = null;
        this.$emit('update');
      } catch (e) {
        this.showNotify({
          type: 'error',
          message: e.message,
        });
      }
    },

    async deleteFile(id, fileIndex) {
      try {
        await deleteLayerAttachment(this.single.id, id);
        this.files.splice(fileIndex, 1);
      } catch (e) {
        console.error(e);
      }
    },

    // полная ерунда нужно переделать на куки
    openAttachmentFile(attachmentPath) {
      openFile(attachmentPath);
    },
  },
};
</script>

<style lang="scss" scoped>

.body-text {
  margin: 4px 0 5px 33px;
  font-size: 0.758rem;
}

.attachment__remove {
  position: absolute;
  right: -8px;
  top: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: red;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:after, &:before {
    content: '';
    display: block;
    width: 2px;
    height: 11px;
    background: white;
    transform: rotate(45deg);
    position: relative;
    left: 1px;
    top: 0;
  }
  &:after {
    transform: rotate(-45deg);
    left: -1px;
    top: 0;
  }
}

.attachments {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 20px;
}


.attachment {
  cursor: pointer;
  position: relative;
  background: rgba(0, 0, 0, .5);
  width: 100%;
  height: 100%;
  font-weight: 600;
  text-align: center;
  transition: transform .3s;
  &:hover {
    transform: scale(1.05);
  }

  & > .mimetype {
    margin: 0;
    color: white;
    position: relative;
    z-index: 2;
  }
}

.attachment__img {
  width: 100%;
  height: 100%;
  max-height: 150px;
  object-fit: contain;
}
</style>
